export default __webpack_public_path__ + "static/media/b11-thumb.4baf2bf8.jpg";